import { useLocSettings } from "../../hooks/SettingsHooks";
import IconWithPopup from "../IconWithPopup";

const CategoryIcons = () => {
  const settings = useLocSettings();
  const specsIndexed = {
    "Type of wood": {
      value: "Oak"
    },
    Finish: {
      value: "Brushed matt lacquer"
    },
    Format: {
      value: "XXL"
    }
  };

  const icons = Object.entries(specsIndexed)
    .map(([field, { value, unit }]) => {
      const icon = settings.specifications?.[field]?.icons?.[value];
      return icon ? { field, value, unit } : null;
    })
    .filter(icon => icon !== null);

  return (
    <div className="icons">
      {icons.map(({ field, value, unit }) => {
        return (
          <IconWithPopup
            field={field}
            value={value}
            unit={unit}
            color={"#fff"}
            key={field + "_" + value}
          />
        );
      })}
    </div>
  );
};

export default CategoryIcons;
